import type { Stamp } from '../../core/stamps';
import './stampCard.css';

/**
 * The Lab Notebook strip (E17, `stamps` arm). Presentational: the boundary decides whether
 * it is drawn and which stamps are newly filled.
 */
export default function StampCard({ stamps, fresh, onToolOpen }: { stamps: readonly Stamp[]; fresh: ReadonlySet<string>; onToolOpen: (tool: string) => void }) {
  return (
    <section className="stamp-card" aria-labelledby="stamp-card-heading">
      <div className="stamp-card-heading">
        <h2 id="stamp-card-heading">Lab Notebook</h2>
        <p>A stamp fills when you finish something in a tool.</p>
      </div>
      <ul className="stamp-card-list">
        {stamps.map(stamp => {
          const className = `stamp${stamp.filled ? ' stamp-filled' : ''}${stamp.tool ? '' : ' stamp-bonus'}${fresh.has(stamp.id) ? ' stamp-fresh' : ''}`;
          const face = (
            <>
              <span className="stamp-mark" aria-hidden="true">{stamp.filled ? '✓' : ''}</span>
              <span className="stamp-label">{stamp.label}</span>
              <span className="stamp-state">{stamp.filled ? 'earned' : 'not yet'}</span>
              {!stamp.filled && <span className="stamp-hint">{stamp.hint}</span>}
            </>
          );
          return (
            <li key={stamp.id} className={className}>
              {stamp.tool && stamp.href && !stamp.filled
                ? <a href={stamp.href} onClick={() => onToolOpen(stamp.tool!)}>{face}</a>
                : <div>{face}</div>}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
